import { render } from "./AppLayoutDefault.vue?vue&type=template&id=7cb16c31&scoped=true&ts=true"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=ts"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=ts"

import "./AppLayoutDefault.vue?vue&type=style&index=0&id=7cb16c31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb16c31"]])

export default __exports__